import Login from "./Login";
import PasswordRecovery from "./PasswordRecovery";
import Registration from "./Registration";
import {useContext, useState} from "react";
import LoginByPhone from "./LoginByPhone";
import {GlobalContext, PopupType, ReducerActionType} from "../../GlobalReducer";
import {CustomerInterface} from "../../interfaces/customer/CustomerInterface";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";

function AuthBlock() {
    // eslint-disable-next-line
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const setCustomer = (customer: CustomerInterface) => {
        dispatch({type: ReducerActionType.SET_PARAM, paramName: 'customer', payload: customer})
        // dispatch({type: ReducerActionType.CLOSE_ALL_POPUP})
    }

    const setBlock = (blockName: string) => {
        console.log(blockName)
    }

    return (<>
            {error && <h4 className={'text-danger text-center'}>{error}</h4>}
            {state.showAuthPopup && <Login setCustomer={setCustomer} setError={setError} setLoading={setLoading} />}
            {state.showAuthByPhonePopup && <LoginByPhone setCustomer={setCustomer} setError={setError} setLoading={setLoading} />}
            {state.showPasswordRecoveryPopup && <PasswordRecovery setError={setError} setLoading={setLoading}/>}
            {state.showRegistrationPopup && <Registration setCustomer={setCustomer} setError={setError} setLoading={setLoading} />}
            <div className="row">
                <div className="col text-center">
                    <small>
                        {!state.showPasswordRecoveryPopup && <span className={"control pointer"} onClick={() => { dispatch({type: ReducerActionType.SHOW_POPUP, payload: PopupType.PASSWORD_RECOVERY}) }} >Забыли пароль?</span>} {state.showRegistrationPopup && <span>&nbsp; / &nbsp;</span>}
                        { (!state.showAuthPopup && !state.showAuthByPhonePopup) && <span className={"control pointer"} onClick={() => { dispatch({type: ReducerActionType.SHOW_POPUP, payload: PopupType.LOGIN}) }}>Авторизация</span>} {!state.showRegistrationPopup && <span>&nbsp; / &nbsp;</span>}
                        {!state.showRegistrationPopup && <span className={"control pointer"} onClick={() => {dispatch({type: ReducerActionType.SHOW_POPUP, payload: PopupType.REGISTRATION})}}>Регистрация</span>}
                    </small>
                </div>
            </div>
        </>)
}

export default AuthBlock